export function handleResponse(response) {
    if (response) {
        return {status: 'success', response: response};
    }
}

export function handleError(error) {
    if (error.data) {
        return new Promise.reject(error.data);
    }
    return Promise.reject(error);
}